import { MetaAdsAdAccount } from '../Types'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { SuccessTag } from '../SuccessTag/SuccessTag'

export const AdAccountCard = ({
  account,
  isSelected,
  onSelect,
}: {
  account: MetaAdsAdAccount
  isSelected: boolean
  onSelect: () => void
}) => {
  const accountInfo = account.additional_data || {}
  const spentAmount = accountInfo.amount_spent || '$0'
  const currency = accountInfo.currency || 'USD'
  const businessName = accountInfo.business_name || account.name
  const businessId = accountInfo.business_id

  return (
    <div className={Styles.card}>
      <div className={Styles.cardLeft}>
        <input
          type="radio"
          name="adAccount"
          value={account.provider_id}
          checked={isSelected}
          onChange={onSelect}
          aria-label={`Select Ad Account ${account.name}`}
          className={Styles.radioInput}
        />
        <div className={Styles.accountInfo}>
          <Text variant="primary" fontWeight="600">
            {account.name}
          </Text>

          <Text variant="secondary">
            <div className={Styles.secondaryAccountInfo}>
              {spentAmount} {currency} Spent {businessId ? `Business: ${businessName} (${businessId})` : ''}
            </div>
          </Text>
        </div>
      </div>
      <div className={Styles.cardRight}>
        {isSelected ? (
          <SuccessTag text="Selected" />
        ) : (
          <Button variant="ghost" size="sm" onPress={onSelect}>
            Use This Account
          </Button>
        )}
      </div>
    </div>
  )
}
